import { useState } from 'react'
import { Mail, X } from 'lucide-react'
import { useLanguage } from '../contexts/LanguageContext'
import { t } from '../locales/translations'
import { BRAND_MARK_URL } from '../config/brand'

const Footer = () => {
  const { language } = useLanguage()
  const [showEmailModal, setShowEmailModal] = useState(false)

  const handleContactClick = (event) => {
    event.preventDefault()
    setShowEmailModal(true)
  }

  return (
    <>
      <footer className="mt-20 border-t border-border bg-white">
        <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
            <div className="col-span-1 md:col-span-2">
              <div className="mb-4 flex items-center space-x-3">
                <img
                  src={BRAND_MARK_URL}
                  alt="Avelia"
                  className="h-10 w-10 rounded-2xl border border-primary/10 object-cover shadow-[0_10px_24px_rgba(255,95,135,0.14)]"
                />
                <div>
                  <h3 className="text-xl font-bold text-text-primary">AVELIA</h3>
                  <p className="text-xs text-text-secondary/80">
                    {language === 'zh' ? '让智能走进真实工作现场' : 'Bring intelligence into real work'}
                  </p>
                </div>
              </div>

              <p className="max-w-md text-sm leading-relaxed text-text-secondary">
                {t(language, 'footer.tagline')}
              </p>

              <div className="mt-6 flex space-x-4">
                <button
                  onClick={handleContactClick}
                  className="rounded-lg border border-border p-2 transition-colors hover:border-primary/35 hover:bg-primary/10"
                >
                  <Mail size={20} className="text-primary" />
                </button>
              </div>
            </div>

            <div>
              <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-primary">
                {t(language, 'footer.product.title')}
              </h4>
              <ul className="space-y-2 text-sm text-text-secondary">
                <li><a href="/features" className="transition-colors hover:text-primary">{t(language, 'footer.product.features')}</a></li>
                <li><a href="/download" className="transition-colors hover:text-primary">{t(language, 'footer.product.download')}</a></li>
                <li><a href="/docs" className="transition-colors hover:text-primary">{t(language, 'footer.product.docs')}</a></li>
                <li><a href="/open-center" className="transition-colors hover:text-primary">{t(language, 'footer.product.openCenter')}</a></li>
              </ul>
            </div>

            <div>
              <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-primary-dark">
                {t(language, 'footer.support.title')}
              </h4>
              <ul className="space-y-2 text-sm text-text-secondary">
                <li>
                  <a href="#" onClick={handleContactClick} className="transition-colors hover:text-primary-dark">
                    {t(language, 'footer.support.contact')}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 border-t border-primary/10 pt-8">
            <div className="flex flex-col items-center justify-between text-sm text-text-muted md:flex-row">
              <p>{t(language, 'footer.copyright')}</p>
              <p className="mt-2 md:mt-0">
                <span className="text-primary">{t(language, 'footer.status.timeline')}:</span> {t(language, 'footer.status.stable')} /
                <span className="ml-2 text-primary-dark">{t(language, 'footer.status.mission')}:</span> {t(language, 'footer.status.active')}
              </p>
            </div>
          </div>
        </div>
      </footer>

      {showEmailModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-[#241822]/65 p-4 backdrop-blur-sm"
          onClick={() => setShowEmailModal(false)}
        >
          <div
            className="relative w-full max-w-md rounded-2xl border border-primary/15 p-8 glass-effect"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              onClick={() => setShowEmailModal(false)}
              className="absolute right-4 top-4 rounded-lg p-2 transition-colors hover:bg-primary/8"
            >
              <X size={20} className="text-text-secondary" />
            </button>

            <div className="text-center">
              <img
                src={BRAND_MARK_URL}
                alt="Avelia"
                className="mx-auto mb-4 h-16 w-16 rounded-3xl border border-primary/10 object-cover shadow-[0_12px_28px_rgba(255,95,135,0.16)]"
              />

              <h3 className="mb-2 text-2xl font-bold text-text-primary">
                {language === 'zh' ? '联系 Avelia' : 'Contact Avelia'}
              </h3>

              <p className="mb-6 text-text-secondary">
                {language === 'zh' ? '品牌合作、投资交流与产品咨询' : 'Brand partnerships, investor conversations, and product inquiries'}
              </p>

              <div className="mb-6 rounded-lg border border-primary/15 p-4 glass-effect">
                <a
                  href="mailto:xautomove@foxmail.com"
                  className="text-lg text-primary transition-colors hover:text-primary-dark"
                >
                  xautomove@foxmail.com
                </a>
              </div>

              <p className="text-sm text-text-muted">
                {language === 'zh' ? '我们会尽快与你取得联系。' : 'We will get back to you as soon as possible.'}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Footer
